import {FormCardSection} from '@/components/ui/form-atoms/FormAtoms'
import {GridItem} from '@/components/ui/grid-atoms/GridAtoms'
import {Text} from '@/components/ui/text/Text'
import {useTranslation} from '@/translations/i18n'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {Button} from '@/components/ui/button/Button'
import {Trash01Icon} from '@/components/ui/icon/Icon'
import {ReferringSpecialist} from '@/features/referring-specialists/types'
import {specialistTitleMapToLabel} from '@/features/referring-specialists/utils'

export const SpecialistCardDetails = ({
    specialist,
    onRemoveSpecialist
}: {
    specialist: ReferringSpecialist
    onRemoveSpecialist?: () => void
}) => {
    const {t} = useTranslation()
    return (
        <Flexbox gap={2} align="center" fullWidth>
            <FormCardSection columnGap={2} columns={3} padding={3}>
                <GridItem direction="column">
                    <Text palette="neutral" shade="500" size="textSm">
                        {t('commons:name_header')}
                    </Text>
                    <Text size="textSm" weight="500">
                        {`${specialist.title && t(specialistTitleMapToLabel[specialist.title]) + ' '}${specialist.lastName} ${specialist.firstName}`}
                    </Text>
                </GridItem>
                <GridItem direction="column">
                    <Text palette="neutral" shade="500" size="textSm">
                        {t('projects:specialist_service_uoc')}
                    </Text>
                    <Text size="textSm" weight="500">
                        {/* {t(projectServiceUocToLabel[specialist.serviceUoc])} */}
                        {specialist.serviceUoc}
                    </Text>
                </GridItem>
                <GridItem direction="column">
                    <Text palette="neutral" shade="500" size="textSm">
                        {t('projects:specialist_email')}
                    </Text>
                    <Text size="textSm" weight="500">
                        {specialist.email}
                    </Text>
                </GridItem>
            </FormCardSection>
            {onRemoveSpecialist && (
                <Button variant="ghost" shape="square" onClick={onRemoveSpecialist}>
                    <Trash01Icon />
                </Button>
            )}
        </Flexbox>
    )
}
